<sm-qr-scanner-overlay
  [isOpen]="isOpen && dialogOpen" [externalScanner]="true" [externalLoading]="busy"
  [externalError]="errorKey ? (errorKey | translate) : ''"
  [retryLabel]="'universalScan.retry' | translate" (retryRequested)="retry()"
  [title]="'universalScan.title' | translate"
  [hint]="(qrOnly ? 'universalScan.qrOnly' : 'universalScan.hint') | translate"
  [loadingLabel]="'barcode.loading' | translate" [closeAriaLabel]="'barcode.close' | translate"
  (videoReady)="startWeb($event)" (closeRequested)="close()">
</sm-qr-scanner-overlay>
